import BeCuponUtils from "@/utils/Utils";

export default class CouponOff {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        couponOffRetrieve(id: ${id}) {
          id
          code
          off
          datetimeStart
          datetimeOff
          usageLimit
          usageLimitUser
          active
          cities {
            id
            name
            region {
              id
              name
              country {
                id 
                name
              }
            }
          }
          coupons {
            id
            title
          }
		      uses {
						profile {
							fullName
							user {
								email
							} 
						}
            payment {
              orders {
                dateTime
                couponsInstance {
                  coupons {
                    id
                    title
                  }
                }							
              }
            }	
				  }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.couponOffRetrieve.dateStart = response.data.data.couponOffRetrieve.datetimeStart.split('T')[0];
    response.data.data.couponOffRetrieve.timeStart = response.data.data.couponOffRetrieve.datetimeStart.split('T')[1].substr(0,5);
    
    response.data.data.couponOffRetrieve.dateOff = response.data.data.couponOffRetrieve.datetimeOff.split('T')[0];
    response.data.data.couponOffRetrieve.timeOff = response.data.data.couponOffRetrieve.datetimeOff.split('T')[1].substr(0,5);
    
    if(response.data.data.couponOffRetrieve.timeStart === "00:00" && response.data.data.couponOffRetrieve.timeOff === "23:59") {
        response.data.data.couponOffRetrieve.fullTime = true;
    }

    response.data.data.couponOffRetrieve.compressed = {
      country: response.data.data.couponOffRetrieve.cities.length ? response.data.data.couponOffRetrieve.cities[0].region.country : null,
      regions: BeCuponUtils.getDistinct(response.data.data.couponOffRetrieve.cities.map(city => city.region.name)),
      cities: response.data.data.couponOffRetrieve.cities,
      coupons: response.data.data.couponOffRetrieve.coupons     
    };

    response.data.data.couponOffRetrieve.country = response.data.data.couponOffRetrieve.cities.length ? response.data.data.couponOffRetrieve.cities[0].region.country.id : null;    
    response.data.data.couponOffRetrieve.regions = BeCuponUtils.getDistinct(response.data.data.couponOffRetrieve.cities.map(city => city.region.id));
    response.data.data.couponOffRetrieve.cities = response.data.data.couponOffRetrieve.cities.map(city => city.id);
    response.data.data.couponOffRetrieve.coupons = response.data.data.couponOffRetrieve.coupons.map(node => node.id);

    return response.data.data.couponOffRetrieve; 
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        couponOffList {
          results {
            id
            code
            off
            datetimeStart
            datetimeOff
            usageLimit
            usageLimitUser
            active
            coupons {
              title
            }            
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    var couponOffList = response.data.data.couponOffList.results.reverse();

    for(var i = 0; i < couponOffList.length; i++) {      
       couponOffList[i].datetimeStart = `${couponOffList[i].datetimeStart.split('T')[0]} | ${couponOffList[i].datetimeStart.split('T')[1].substr(0,5)}`;
       couponOffList[i].datetimeOff = `${couponOffList[i].datetimeOff.split('T')[0]} | ${couponOffList[i].datetimeOff.split('T')[1].substr(0,5)}`;
       couponOffList[i].coupons = couponOffList[i].coupons.map(node => node.title).join(' | ');
    }

    return couponOffList;
    // return response.data.data.couponOffList.results.reverse();    
  }

  static async create(payload) 
  {
    const response = await payload.axios.post(
      '/graphql/',
      `mutation {
        createCouponOff(newCouponoff: {
          code: "${payload.code}", 
          off: ${payload.off},
          datetimeStart: "${payload.datetimeStart}", 
          datetimeOff: "${payload.datetimeOff}", 
          usageLimit: ${payload.usageLimit}, 
          usageLimitUser: ${payload.usageLimitUser}, 
          active: ${payload.active}, 
          cities: ${payload.cities},
          coupons: ${payload.coupons}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCouponOff.ok;
  }

  static async edit(payload) 
  {
    const response = await payload.axios.post(
      '/graphql/',
      `mutation {
        updateCouponOff(newCouponoff: {
          id: ${payload.id}, 
          code: "${payload.code}", 
          off: ${payload.off},
          datetimeStart: "${payload.datetimeStart}", 
          datetimeOff: "${payload.datetimeOff}", 
          usageLimit: ${payload.usageLimit}, 
          usageLimitUser: ${payload.usageLimitUser}, 
          active: ${payload.active}, 
          cities: ${payload.cities},
          coupons: ${payload.coupons}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateCouponOff.ok;
  }

  static async delete(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `mutation{
        deleteCouponOff(id: ${payload.id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteCouponOff.ok;
  }  
}